import { Navigate, useLocation } from "react-router-dom";

/** Board groups the index route forwards `?group=` to (old links and bookmarks: `/?group=songs`). */
export const BOARD_GROUPS = ["videos", "songs", "renders"] as const;

/** Where `/` goes: `/board/<group>` for a known `?group=` (else videos); every other query param is kept. */
export function indexTarget(search: string): string {
  const sp = new URLSearchParams(search);
  const g = sp.get("group") ?? "";
  sp.delete("group");
  const group = (BOARD_GROUPS as readonly string[]).includes(g) ? g : "videos";
  const rest = sp.toString();
  return `/board/${group}${rest ? `?${rest}` : ""}`;
}

export function IndexRedirect() {
  const loc = useLocation();
  return <Navigate to={`${indexTarget(loc.search)}${loc.hash}`} replace />;
}

/** Permanent alias of a page (e.g. `/renders` → `/board/renders`); the query string and hash are kept. */
export function Forward({ to }: { to: string }) {
  const loc = useLocation();
  return <Navigate to={`${to}${loc.search}${loc.hash}`} replace />;
}
